export const LS_RATE_TABLE_KEY = 'even_rate_table'
